class ThemeGtm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrackingClicks = this.handleTrackingClicks.bind(this)
    this.handleCollectionUrl = this.handleCollectionUrl.bind(this)
    this.handlePromoInView = this.handlePromoInView.bind(this)

    this.listeners.add(document, 'click', this.handleTrackingClicks)

    if (window.location.pathname.includes('/collections')) {
      this.handleCollectionUrl()
    }

    if (window.location.pathname.includes('/cart')) {
      this.handleCartUrl()
    }

    const targets = document.querySelectorAll(
      '[data-theme-gtm-el="view_promotion"]',
    )

    if (targets.length) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.handlePromoInView(entry.target)
              observer.unobserve(entry.target)
            }
          })
        },
        {
          root: null,
          threshold: 0.1,
        },
      )

      targets.forEach((target) => observer.observe(target))
    }
  }

  handleTrackingClicks (event) {
    const clickedGtmEl = event.target.closest('[data-theme-gtm-el]')

    if (!clickedGtmEl) return

    if (clickedGtmEl.dataset.themeGtmEl === 'select_item') {
      this.handleSelectItemClick(clickedGtmEl)
    }

    if (clickedGtmEl.dataset.themeGtmEl === 'select_promotion') {
      this.handleSelectPromoClick(clickedGtmEl)
    }

    if (clickedGtmEl.dataset.themeGtmEl === 'remove_from_cart') {
      this.handleRemoveClick(clickedGtmEl)
    }

    if (clickedGtmEl.dataset.themeGtmEl === 'navigation_click') {
      this.handleNavigationClick(clickedGtmEl)
    }
  }

  handleSelectItemClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEl,
        ecommerce: {
          items: [
            {
              item_name: clickedGtmEl.dataset.themeGtmItemName,
              item_id: clickedGtmEl.dataset.themeGtmItemId,
            },
          ],
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleSelectPromoClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEl,
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleCollectionUrl () {
    const items = []

    const products = document.querySelectorAll(
      '[data-theme-gtm-el="select_item"]',
    )
    products.forEach((productEl) => {
      items.push({
        item_name: productEl.dataset.themeGtmItemName,
        item_id: productEl.dataset.themeGtmItemId,
      })
    })

    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          items,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleRemoveClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEl,
        ecommerce: {
          items: [
            {
              item_name: clickedGtmEl.dataset.themeGtmItemName,
              item_id: clickedGtmEl.dataset.themeGtmItemId,
            },
          ],
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleCartUrl () {
    const items = []

    const products = document.querySelectorAll(
      '[data-theme-gtm-el="view_item"]',
    )
    products.forEach((productEl) => {
      items.push({
        item_name: productEl.dataset.themeGtmItemName,
        item_id: productEl.dataset.themeGtmItemId,
      })
    })

    const cart = document.querySelector('[data-theme-gtm-el="view_cart"]')

    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'view_cart',
        ecommerce: {
          currency: cart.dataset.themeGtmCurrency,
          value: Number(cart.dataset.themeGtmValue),
          items,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handlePromoInView (element) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: element.dataset.themeGtmEl,
        ecommerce: {
          items: [
            {
              item_name: element.dataset.themeGtmItemName,
            },
          ],
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleNavigationClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'sitewide_click',
        click_type: 'navigation',
        click_id: 'navigation',
        navigation: {
          link_text: clickedGtmEl.dataset.themeGtmNavTitle,
          link_url: clickedGtmEl.dataset.themeGtmNavUrl,
          navigation_level: clickedGtmEl.dataset.themeGtmNavLevel,
        },
      })
    } catch (error) {
      console.error('Error pushing navigation click to dataLayer: ', error)
    }
  }
}

if (!customElements.get('theme-gtm')) {
  customElements.define('theme-gtm', ThemeGtm)
}
